import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert, ScanLine } from 'lucide-react';
import { useAdminContext } from './adminContext';
import { AdminStaffModule } from '../../components/admin/AdminStaffModule';

export function AdminTeamPage() {
  const { adminKey, currentUser } = useAdminContext();

  const userRole = currentUser?.role as string | undefined;
  const isRestrictedRole =
    userRole === 'staff' ||
    userRole === 'gate' ||
    userRole === 'desk' ||
    userRole === 'operations';

  if (isRestrictedRole) {
    return (
      <div className="max-w-md mx-auto my-12 p-6 bg-white border border-amber-200 rounded-2xl shadow-sm text-center space-y-4">
        <div className="w-12 h-12 mx-auto rounded-full bg-amber-50 text-amber-600 border border-amber-200 flex items-center justify-center">
          <ShieldAlert className="w-6 h-6" />
        </div>
        <h3 className="text-lg font-bold text-slate-900">Restricted Administration Area</h3>
        <p className="text-sm text-slate-600">
          Field operations, helpdesk, and gate staff do not have permission to manage team accounts and roles.
        </p>
        <Link
          to="/admin/operations"
          className="inline-flex items-center justify-center gap-2 w-full py-2.5 px-4 bg-[#0A3D27] hover:bg-[#062B1B] text-white rounded-xl text-sm font-semibold transition-colors shadow-xs"
        >
          <ScanLine className="w-4 h-4" />
          <span>Go to Live Operations &amp; Helpdesk</span>
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      <AdminStaffModule adminKey={adminKey} currentUser={currentUser} />
    </div>
  );
}

export default AdminTeamPage;
